import BaseStore from '@src/utils/store/base-store';
import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import { useRequest } from 'ahooks';
import cmsApi from '@src/services/cms-api';

class ArticleStore extends BaseStore {
  // 文章 ID
  @observable articleId = '11869';

  // 分类 ID
  @observable categoryId = '7841';

  // 文章标题
  @observable title = '';

  // 文章内容
  @observable content = '';

  // 文章详情数据
  @observable articleDetail = null;

  /**
   * 获取文章详情
   * @returns {Promise<*>}
   */
  @autobind
  async fetchArticleDetailAsync() {
    if (!this.categoryId || !this.articleId) {
      return;
    }
    return cmsApi.getArticleDetail({
      categoryId: this.categoryId,
      articleId: this.articleId,
      api: 'https://jxsj.xoyo.com/api.php' // 根据项目约定设置默认 API
    });
  }

  use() {
    super.use();

    // 监听 articleId 和 categoryId 变化自动请求
    useRequest(this.fetchArticleDetailAsync, {
      refreshDeps: [this.articleId, this.categoryId],
      onSuccess: res => {
        if (res) {
          this.articleDetail = res[0];
          this.content = res[0].content || '';
        }
      }
    });
  }
}

export default ArticleStore;
